import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.scss'

export default class BackButton extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
  }

  static defaultProps = {
    onClick: f => f,
    className: '',
  }

  render() {
    return (
      <button
        type="button"
        onClick={this.props.onClick}
        className={classNames(styles.back, this.props.className)}
      >
        Back
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./components/BackButton/index.jsx